import { createContext, useContext } from 'react';

export type UsercentricsContextValue = {
  isCmpEnabled: boolean;
  isInitialized: boolean;
  /** True when the CMP loader was present but __ucCmp never became available. */
  cmpLoadFailed: boolean;
  consents: Record<string, boolean>;
  refreshConsents: () => Promise<void>;
};

export const UsercentricsContext = createContext<UsercentricsContextValue | null>(null);

export const useUsercentricsContext = (): UsercentricsContextValue => {
  const context = useContext(UsercentricsContext);

  if (!context) {
    throw new Error('useUsercentricsContext must be used within a UsercentricsProvider');
  }

  return context;
};
